import script from "./TermsPrivacyView.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsPrivacyView.vue?vue&type=script&setup=true&lang=js"

import "./TermsPrivacyView.vue?vue&type=style&index=0&id=dd1a5f74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd1a5f74"]])

export default __exports__